import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '../../../../../node_modules/@angular/router'
import { CpmService } from '../../../service/cpm.service'

@Component({
  selector: 'app-full-fact-sheet-screen',
  templateUrl: './full-fact-sheet-screen.component.html',
  styleUrls: ['./full-fact-sheet-screen.component.scss']
})
export class FullFactSheetScreenComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/full-fact-sheet/full-fact-sheet-screen/full-fact-sheet-screen.component.ts